import { render, staticRenderFns } from "./convocationList.view.vue?vue&type=template&id=f33f9ee0&scoped=true&lang=pug"
import script from "./convocationList.view.vue?vue&type=script&lang=ts"
export * from "./convocationList.view.vue?vue&type=script&lang=ts"
import style0 from "./convocationList.view.vue?vue&type=style&index=0&id=f33f9ee0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33f9ee0",
  null
  
)

export default component.exports